import React from "react"

const Footer = () => (
  <footer>&copy; Brian Redmond</footer>
)

export default Footer
